// dashboard

import LandingPage from '../pages/Landing';
import { AllCompanies } from '../pages/Landing/AllCompanies';
import { Employers } from '../pages/Landing/employers';
import { Employees } from '../pages/Landing/employees';
import FAQPage from '../pages/Landing/FAQPage';
import PrivacyPolice from '../pages/Landing/PrivacyPolice/PrivacyPolice';

export const routes = [
  {
    name: 'Landing',
    key: '',
    path: `/`,
    component: LandingPage,
    children: [
      {
        name: 'Landing1',
        key: '',
        path: `/`,
        component: Employees,
        children: [],
        config: {
          layout: 'none-layout',
          isSidebar: false,
          isAuth: false,
        },
      },
      {
        name: 'Landing1',
        key: '',
        path: `/employers`,
        component: Employers,
        children: [],
        config: {
          layout: 'none-layout',
          isSidebar: false,
          isAuth: false,
        },
      },
      {
        name: 'Landing1',
        key: '',
        path: `/view/:type`,
        children: [],
        component: AllCompanies,
        config: {
          layout: 'none-layout',
          isSidebar: false,
          isAuth: false,
        },
      },
      {
        name: 'FAQPage',
        key: '',
        path: `/faq`,
        children: [],
        component: FAQPage,
        config: {
          layout: 'none-layout',
          isSidebar: false,
          isAuth: false,
        },
      },
      {
        name: 'PrivacyPolicy',
        key: '',
        path: `/privacy-policy`,
        children: [],
        component: PrivacyPolice,
        config: {
          layout: 'none-layout',
          isSidebar: false,
          isAuth: false,
        },
      },
    ],
    config: {
      layout: 'none-layout',
      isSidebar: false,
      isAuth: false,
    },
  },
];
